import * as React from "react";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "chevron-right_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M19.5 12a2.3 2.3 0 0 1-.78 1.729L7.568 23.54a1.847 1.847 0 0 1-2.439-2.773l9.752-8.579a.25.25 0 0 0 0-.376L5.129 3.233A1.847 1.847 0 1 1 7.568.46l11.148 9.808A2.3 2.3 0 0 1 19.5 12" }));
export { SvgChevronRight as ReactComponent };
